import { fillHomeLoanCompareProductSplit } from '__core/shared/util/salestrekker';
import template from './switchReviewProduct.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    lender: '<',
    lenderDocument: '<',
    switchReviewProduct: '<',
    switchCompareProduct: '<',
    idTicket: '<',
    onChanged: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      helperService,
      homeLoanService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableTermInYears = [];
      ctrl.availableAbsLendingPurposeCodes = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: true });
        ctrl.availableAbsLendingPurposeCodes = homeLoanService.getAvailableAbsLendingPurposeCodes();
        ctrl.lender = ctrl.lender || {};
        ctrl.lenderDocument = ctrl.lenderDocument || {};
        ctrl.switchReviewProduct = ctrl.switchReviewProduct || {};
        ctrl.switchCompareProduct = ctrl.switchCompareProduct || {};
        ctrl.switchReviewProductSplit = ctrl.switchReviewProduct?.productSplits[0] || {};
        ctrl.idTicket = ctrl.idTicket || {};
        ctrl.homeLoanCompareProductEstimate();
        ctrl.isReady = true;
      };

      ctrl.homeLoanCompareProductEstimate = () => {
        ctrl.isProcessing = true;
        ctrl.compareProductParams = {
          switchReviewProducts: [ctrl.switchReviewProduct],
          switchCompareProducts: [ctrl.switchCompareProduct]
        };
        financesService
          .homeLoanProductsCompare({
            idTicket: ctrl.idTicket,
            compareProductParams: ctrl.compareProductParams,
            isSwitched: true
          })
          .then((res) => {
            if (res?.status && res?.compareProductEstimate?.length) {
              const [reviewProductSplit, compareProductSplit] = fillHomeLoanCompareProductSplit(
                res?.compareProductEstimate[0].productSplits[0],
                null,
                ctrl.switchReviewProduct.productSplits[0],
                ctrl.switchCompareProduct.productSplits[0]
              );
              ctrl.switchReviewProductSplit = reviewProductSplit;
              ctrl.switchReviewProduct.productSplits[0] = reviewProductSplit;
              ctrl.switchCompareProduct.productSplits[0] = compareProductSplit;
            }
            const data = {
              switchReviewProduct: ctrl.switchReviewProduct,
              switchCompareProduct: ctrl.switchCompareProduct
            };
            ctrl.isProcessing = false;
            ctrl.onFinished({ data });
            ctrl.changeInterestOnly();
          });
      };

      ctrl.changeInterestOnly = () => {
        ctrl.onChanged({
          status: !(
            (ctrl.isProductIO({ productSplit: ctrl.switchReviewProductSplit }) &&
              !ctrl.switchReviewProductSplit?.interestOnlyTerm) ||
            ctrl.isProcessing
          )
        });
      };

      ctrl.isProductIO = ({ productSplit }) =>
        homeLoanService.isProductIO({ product: productSplit });

      ctrl.reviewProductChanges = _.debounce(() => {
        ctrl.switchReviewProduct.productSplits[0] = ctrl.switchReviewProductSplit;
        ctrl.homeLoanCompareProductEstimate();
      }, 3000);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
